(() => {
  'use strict';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer;
  function initialize() {
    observer?.disconnect();
    document.body.dataset.csMotion = reduced.matches ? 'reduced' : 'enabled';
    if (reduced.matches || !('IntersectionObserver' in window)) return;
    observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (entry.target.hasAttribute('data-cs-world-stage')) {
          entry.target.classList.toggle('cw-stage--visible', entry.isIntersecting);
        } else if (entry.isIntersecting) {
          entry.target.classList.add('cw-revealed');
          observer.unobserve(entry.target);
        }
      }
    }, { threshold: 0.08 });
    document.querySelectorAll('[data-cs-world-stage], [data-cs-world-reveal]').forEach(element => observer.observe(element));
  }
  initialize();
  reduced.addEventListener('change', initialize);
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('visibilitychange', () => {
    document.body.dataset.csMotion = document.hidden || reduced.matches ? 'reduced' : 'enabled';
  });
})();
